<div *ngIf="loading$ | async" class="loading-overlay">
  <div class="loading-spinner">
    <!-- You can use a spinner icon or CSS animation here -->
    <p>Loading...</p>
  </div>
</div>
